// extracted by mini-css-extract-plugin
export default {"root":"IconSocialMediaTwitter_root__fvHE4"};